import {Box, Button, Checkbox, FormControlLabel, Paper, Stack, styled, TextField, Typography} from "@mui/material";
import {useAuth} from "../auth/AuthProvider";
import {useState} from "react";
import {CardOutline} from "./ProductCard";

const Error = styled(Paper)(() => ({
    backgroundColor: "red",
    padding: '1rem',
}));

const FilterLabel = styled(Typography)(({theme}) => ({
    font: theme.typography.subtitle2.font,
    fontSize: theme.typography.subtitle2.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: 2,
}));

const SubmitButton = styled(Button)(({theme}) => ({
    backgroundColor: theme.palette.contrastGrey.main,
    color: '#000',
    textTransform: 'none',
    "&:hover": {
        backgroundColor: theme.palette.contrastGrey.dark,
        color: '#fff',
    },
}));

const LoginCard = ({color}) => {
    const {signIn} = useAuth();
    const [showError, setShowError] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        await signIn(data, setShowError);
    };

    return (
        <CardOutline title="Sign in" color={color}>
            {showError && (
                <Error elevation={0}>
                    <Typography variant="body2" sx={{color: "#fff"}}>
                        A valid account with these details could not be found
                    </Typography>
                </Error>
            )}

            <Box component="form" onSubmit={handleSubmit}>
                <Stack spacing={2}>
                    <Stack>
                        <FilterLabel>Username</FilterLabel>
                        <TextField id="username" name="username" type="text" size="small" required autoComplete="email" autoFocus/>
                    </Stack>

                    <Stack>
                        <FilterLabel>Password</FilterLabel>
                        <TextField id="password" name="password" type="password" size="small" required/>
                    </Stack>

                    <SubmitButton id="submit" name="submit" type="submit" variant="contained">Sign in</SubmitButton>

                    <FormControlLabel
                        control={<Checkbox name="remember" value="remember" color="primary"/>}
                        label="Remember me on this computer"
                    />
                </Stack>
            </Box>

            <Button sx={{textTransform: "none"}} href="/resetPassword">Reset password</Button>
        </CardOutline>
    );
};

export default LoginCard;
